import { getLiveDataSyncUrls } from "./liveDataSync";

export const HOME_BANNER_STORAGE_KEY = "trw-home-banner-slides-v1";
export const HOME_BANNER_UPDATED_EVENT = "trw:home-banner-updated";

const DEFAULT_SLIDES = [
  {
    id: "banner-deals-2026",
    image: "/assets/images/home/rethink-ways-best-travel-deals-2026.avif",
    thumb: "/assets/images/home/rethink-ways-best-travel-deals-2026-thumb.avif",
    title: "Best Travel Deals 2026: International Vacation Offers| Travel Rethink Ways",
    tag: "DEALS",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/",
    tagLink: "https://travel.rethinkways.com/international-travel-deals-2026/",
    mobilePosition: "95% center",
    headline: "Top Travel Deals for International Trips 2026",
    mobileHeadline: "Top Travel Deals for International Trips 2026",
    sub: "Smart travel deals that save time, money & effort under the stars.",
    cta: "Grab the Deals",
  },
  {
    id: "banner-maldives-honeymoon",
    image: "/assets/images/home/rethink-ways-maldives-honeymoon-banner.avif",
    thumb: "/assets/images/home/rethink-ways-maldives-honeymoon-banner-thumb-1.avif",
    title: "Maldives Honeymoon Guide: Dreamy Escapes for Every Couple | Travel Rethink Ways",
    tag: "HONEYMOON GLOBAL",
    link: "https://travel.rethinkways.com/maldives-honeymoon/",
    tagLink: "https://travel.rethinkways.com/category/honeymoon-global/",
    mobilePosition: "95% center",
    headline: "The Perfect Maldives Honeymoon Awaits for You",
    mobileHeadline: "The Perfect Maldives Honeymoon Awaits for You",
    sub: "Wake up over the ocean, dine under the stars and unwind together.",
    cta: "Escape to Maldives",
  },
  {
    id: "banner-india-june",
    image: "/assets/images/home/rethink-ways-30-best-places-india.avif",
    thumb: "/assets/images/home/rethink-ways-30-best-places-india.avif",
    title: "30 Best Places to Visit in India in September 2026 | Travel Rethink Ways",
    tag: "INDIA 2026",
    link: "https://travel.rethinkways.com/30-best-places-to-visit-india-in-september/",
    tagLink: "https://travel.rethinkways.com/category/india-2026/",
    mobilePosition: "99% center",
    headline: "September Escapes Across Beautiful India 2026",
    mobileHeadline: "September Escapes 2026",
    sub: "Discover 30 Beautiful Places for a Refreshing Getaway",
    cta: "View All Places",
  },
  {
    id: "banner-india-deals-2026",
    image: "/assets/images/home/rethink-ways-India-travel-deals-2026.avif",
    thumb: "/assets/images/home/rethink-ways-India-travel-deals-2026-thumb.avif",
    title: "India Travel Deals 2026: Top Domestic Vacation Offers| Travel Rethink Ways",
    tag: "DEALS",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/",
    tagLink: "https://travel.rethinkways.com/india-travel-deals-2026/",
    mobilePosition: "95% center",
    headline: "India Getaways with Smart Travel Deals",
    mobileHeadline: "India Getaways with Smart Travel Deals",
    sub: "Get the best value on trips across India without the hassle.",
    cta: "Start Planning",
  },
  {
    id: "banner-thailand-visa-free",
    image: "/assets/images/home/rethink-ways-visa-free-thailand.avif",
    thumb: "/assets/images/home/rethink-ways-visa-free-thailand.avif",
    title: "Philippines VISA Requirements 2026 Guide | Travel Rethink Ways",
    tag: "VISA FREE",
    link: "https://travel.rethinkways.com/philippines-visa-guide-for-indians-2026/",
    tagLink: "https://travel.rethinkways.com/category/visa-free/",
    mobilePosition: "95% center",
    headline: "Philippines Visa-Free Travel from India 2026",
    mobileHeadline: "Visa Free Thailand Travel For Indians 2026",
    sub: "Skip the Visa, Start Your Island Adventure.",
    cta: "Read Full Guide",
  },
];

function safeParse(value, fallback) {
  try {
    const parsed = JSON.parse(value);
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
}

function getHomeBannerSyncUrls() {
  if (typeof window === "undefined") return [];
  return getLiveDataSyncUrls();
}

function getHomeBannerSyncHeaders() {
  const headers = { "Content-Type": "application/json" };
  if (typeof window === "undefined") return headers;
  const nonce = String(window.TRW_SYNC_NONCE || window.wpApiSettings?.nonce || "").trim();
  if (nonce) headers["X-WP-Nonce"] = nonce;
  try {
    const token = String(window.TRW_SYNC_TOKEN || window.localStorage.getItem("trw-sync-token") || "").trim();
    if (token) headers["X-TRW-Sync-Token"] = token;
  } catch {
    /* ignored */
  }
  return headers;
}

function buildHomeBannerSyncPayload() {
  return {
    homeBanner: getStoredHomeBannerSlides(),
  };
}

function parseHomeBannerRemotePayload(data) {
  const outer = data?.data ?? data;
  const inner = outer?.homeBanner ?? outer;
  return Array.isArray(inner) ? inner : [];
}

function hasMeaningfulHomeBannerPayload(slides) {
  return Array.isArray(slides) && slides.length > 0;
}

let _homeBannerHydrated = false;
let _homeBannerSaving = false;
let _homeBannerPendingSave = false;

export async function hydrateHomeBannerFromRemote(force = false) {
  if (typeof window === "undefined" || (_homeBannerHydrated && !force)) return false;
  _homeBannerHydrated = true;
  const urls = getHomeBannerSyncUrls();
  for (const url of urls) {
    try {
      const response = await fetch(url, { method: "GET", credentials: "same-origin", cache: "no-store" });
      if (!response.ok) continue;
      const json = await response.json();
      const slides = parseHomeBannerRemotePayload(json);
      if (!hasMeaningfulHomeBannerPayload(slides)) continue;
      window.localStorage.setItem(HOME_BANNER_STORAGE_KEY, JSON.stringify(slides));
      window.dispatchEvent(new Event(HOME_BANNER_UPDATED_EVENT));
      return true;
    } catch {
      /* try next */
    }
  }
  return false;
}

export async function saveHomeBannerSlidesToRemote() {
  if (typeof window === "undefined") return false;
  const urls = getHomeBannerSyncUrls();
  if (!urls.length) return false;
  if (_homeBannerSaving) {
    _homeBannerPendingSave = true;
    return false;
  }
  _homeBannerSaving = true;
  _homeBannerPendingSave = false;
  try {
    for (const url of urls) {
      try {
        const response = await fetch(url, {
          method: "POST",
          credentials: "same-origin",
          headers: getHomeBannerSyncHeaders(),
          body: JSON.stringify(buildHomeBannerSyncPayload()),
        });
        if (!response.ok) continue;
        return true;
      } catch {
        /* try next */
      }
    }
    return false;
  } finally {
    _homeBannerSaving = false;
    if (_homeBannerPendingSave) saveHomeBannerSlidesToRemote();
  }
}

export function getDefaultHomeBannerSlides() {
  return DEFAULT_SLIDES;
}

export function getStoredHomeBannerSlides() {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(HOME_BANNER_STORAGE_KEY);
  const parsed = raw ? safeParse(raw, []) : [];
  return Array.isArray(parsed) ? parsed : [];
}

export function getHomeBannerSlides({ includeStoredOverrides = true } = {}) {
  const base = getDefaultHomeBannerSlides();
  if (!includeStoredOverrides || typeof window === "undefined") return base;
  const stored = getStoredHomeBannerSlides();
  return stored.length ? stored : base;
}

export function setHomeBannerSlides(nextSlides) {
  if (typeof window === "undefined") return;
  const payload = Array.isArray(nextSlides) ? nextSlides : [];
  window.localStorage.setItem(HOME_BANNER_STORAGE_KEY, JSON.stringify(payload));
  window.dispatchEvent(new Event(HOME_BANNER_UPDATED_EVENT));
  saveHomeBannerSlidesToRemote();
}
